import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import { Pagination, Navigation } from 'swiper/modules';
import { createApp } from 'vue';
import NewProductsList from '../components/NewProductsList.vue';

createApp(NewProductsList).mount('#new-products-vue');